module.exports = __webpack_public_path__ + "images/01e67443223b1ee0f509a7cb396270d6.svg";